import React from "react";
import { connect } from "react-redux";
import TopNav from "../../components/common/TopNav/TopNav";
import SideNav from "../../components/common/SideNav/SideNav";
import Footer from "../../components/common/Footer/Footer";
import commonLabels from "../../constants/messageConstants";
import "./layout.less";
import FullPageLoader from "../loader/fullPage-loader";
import { API_URL } from "../../constants/api";
import ToastMessage from "../../components/common/toastMsg";
import { routes } from "../../constants/routes";
import WorkSpace from "../workspace";
import { apiBatchRequest, apiRequest } from "../../utils/api_service";
import ErrorPage from "../ErrorPage";
// import DatacenterUser from "../../components/Dashboard/DatacenterUser/DatacenterUser";
// import { Route } from "react-router-dom";
import { getUserData } from "../../store/user/actions";
import TenantLogin from "../tenantLogin/tenantLogin";
import { IsSectionVisible, PaperComponent } from "../../utils/helper";
import { SECTIONS } from "../../constants/appConstants";
import DownloadProgress from "../../components/common/download-progress-bar";
import moment from "moment";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
} from "@material-ui/core";
import { InfoOutlined } from "@material-ui/icons";
import DatePicker from "../../components/common/DatePicker/DatePicker";
import DenseTable from "../../components/Dashboard/RenderTable";
import camelCaseKeys from "camelcase-keys";
import { Workbook } from "react-excel-workbook";
import DownloadIcon from "@material-ui/icons/CloudDownloadOutlined";
import { isMobile,isTablet } from "react-device-detect";
import DatacenterNotification from "../../components/common/TopNav/notification"
const MissingSyncColumns = [
  { key: "dataSource", name: "Data Source" },
  { key: "missingDate", name: "Missing Date" },
];
const SyncColumns = [
  { key: "sourceSystem", name: "Source System" },
  { key: "dataSource", name: "Data Source" },
  { key: "sourceType", name: "Source Type" },
  { key: "dataLoadType", name: "Load Type" },
  { key: "frequency", name: "Frequency" },
  { key: "dataLoadDate", name: "Data Load Date" },
  { key: "sourceDataFrom", name: "Source Data From" },
  { key: "sourceDataTo", name: "Source Data To" },
  { key: "status", name: "Status" },
  { key: "recordCount", name: "Record Count" },
];

class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      syncStartDate: new moment()
        .subtract(1, "months")
        .startOf("month")
        .format("MM/DD/YYYY"),
      syncEndDate: new moment()
        .subtract(1, "months")
        .endOf("month")
        .format("MM/DD/YYYY"),
      SyncData: undefined,
    };
  }

  
  componentDidMount() {
    if (window.location.pathname != "/" + routes.error) { /* empty */ }
    if (this.props.userData == null || this.props.userData == undefined) {
      this.props.getUserData();
    }
  }

  /** Call to set start and end date */
  onDateRange = (startDate, endDate) => {
    this.setState({ syncStartDate: startDate, syncEndDate: endDate });
  };

  /** Data sync details */
  getDataSyncDetails = (startDate, endDate) => {
    const params = {
      endDate: endDate,
      startDate: startDate,
      dataSource: this.state.selectedDataSource,
      status: this.state.SelectedSyncStatus,
    };
    apiRequest({
      url: API_URL.datacenter.GetDataSyncStatus,
      params,
    }).then((SynchData) => {
      const{selectedDataSource,SelectedSyncStatus}= this.state;
      this.setState({
        SyncData: camelCaseKeys(SynchData.data || []).filter(
          (x) =>
            (x.dataSource === selectedDataSource ||
              selectedDataSource === undefined ||
              selectedDataSource === "") &&
            (x.status === SelectedSyncStatus ||
              SelectedSyncStatus === undefined ||
              SelectedSyncStatus === "")
        ),
      });
    });
  };

  
  /** Missing data sync detials */
  getMissingDataSyncDetails = (startDate, endDate) => {
    const params = {
      endDate: endDate,
      startDate: startDate,
    };
    apiRequest({
      url: API_URL.datacenter.GetMissingDataSyncStatus,
      params,
    }).then((MissingSynchData) => {
      this.setState({
        MissingSyncData: camelCaseKeys(MissingSynchData.data || []),
        openMissingPopup: true,
      });
    });
  };

  /** Download data */
  DownloadData = (SynchData) => {
    return (
      <Workbook
        filename={
          "Sync history" +
          " from " +
          this.state.syncStartDate.replace("/", "_") +
          " to " +
          this.state.syncEndDate.replace("/", "_") +
          "_data.xlsx"
        }
        element={
          <Tooltip title={"Download"}>
            <IconButton button divider>
              <DownloadIcon fontSize={"small"} />
            </IconButton>
          </Tooltip>
        }
      >
        <Workbook.Sheet data={SynchData} name={"Sync History"}>
          {SyncColumns.map((column, index) => (
            <Workbook.Column key={"column"+index} label={column.name} value={column.key} />
          ))}
        </Workbook.Sheet>
      </Workbook>
    );
  };

  /** Open missing popup details */
  openMissingPopupDetails = () => {
    this.getMissingDataSyncDetails(
      this.state.syncStartDate,
      this.state.syncEndDate
    );
  };
  
  render() {
    const { layout, requestCount, userData } = this.props;
    const group = ((userData?.groups || [])[0] || {}).groupName;

    let defaultRoute = null;
    if (layout.isAuthenticated) {
      if (IsSectionVisible(SECTIONS.WELCOME))
        defaultRoute = routes.welcome;
      else if (IsSectionVisible(SECTIONS.DASHBOARD))
        defaultRoute = routes.adminDashboard;
      else if (IsSectionVisible(SECTIONS.SDC_GRANT_ACCESS))
        defaultRoute = routes.newGrantAccess;
      else if (userData?.dcopConfiguration)
        defaultRoute = userData?.dcopConfiguration[0].DefaultRoute;
      else if (group === "DC_Contractor" && IsSectionVisible(SECTIONS.HSE_INCIDENT_MENU))
        defaultRoute = routes.healthAndSafety;
      else defaultRoute = routes.adminDashboard;
    } else defaultRoute = routes.tenantLogin;
    const isAzureAd =
      localStorage.getItem("DCLT") === "/dc-user" ? true : false;
    const showLastSyncInfo =
      window.location.pathname.toLowerCase() == "/KPi" ||
      window.location.pathname.toLowerCase() == "/Dashboard";
      
      localStorage.setItem("IsInEditMode",0)
    const selectedMenu = defaultRoute === "welcome" ? 11 : defaultRoute === "tenant" ? 1 : defaultRoute === "SDCGrantAccess" === 0 ? 10 : 0
    console.log(selectedMenu)
    return (
      <>
        <ToastMessage />
        <FullPageLoader requestCount={requestCount} />
        {layout.isAuthenticated == true ? (
          <div className={"layout-header-container"}>
            <TopNav />
          </div>
        ) : null}
        <DownloadProgress />
        <div className={"layout-body-wrapper"}>
          {layout.isAuthenticated == true ? 
           isMobile===true || isTablet===true? <></> : <div className={"layout-sidebar"}>
               <SideNav type={"mobile"} selectedTab={selectedMenu} /> 
                                                       </div>
           : null}

          <div
            className={
              layout.isAuthenticated == true
                ? "layout-selected-route-container"
                : "w-100"
            }
          >
            {/* <DatacenterUser />*/}
            {this.props.userData != null && this.props.userData != undefined ? (
              <>
               <DatacenterNotification {...this.props} />
                {layout.isInErrorState == true ? (
                  <ErrorPage details={commonLabels.unAuthorizedAccess} />
                ) : null}
                {
                  <>
                    {isAzureAd && showLastSyncInfo && (
                      <div className={"col-xs pull-right end-xs"}>
                        <Tooltip title={"Data Last Synced"}>
                          <IconButton
                            size={"small"}
                            onClick={() => {
                              this.setState({ openSynchDialog: true });
                            }}
                            style={{ padding: "3px" }}
                          >
                            <IconButton size={"small"}>
                              <InfoOutlined
                                size={"small"}
                                fontSize={"small"}
                              />
                            </IconButton>
                          </IconButton>
                        </Tooltip>
                      </div>
                    )}
                    <WorkSpace
                      defaultPage={defaultRoute}
                      userData={this.props.userData}

                      // asOfDate={layout.asOfDate.date}
                    />
                    {/* {isAzureAd && <SilentTokenRenew />} */}
                  </>
                }
              </>
            ) : (
              <>{layout.isAuthenticated != true && <TenantLogin />}</>
            )}
          </div>
        </div>
        {this.state.openSynchDialog && isAzureAd && (
          <Dialog
            fullScreen={false}
            open={this.state.openSynchDialog}
            maxWidth={"lg"}
            onClose={() => {
              this.setState({ openSynchDialog: false });
            }}
            aria-labelledby={"n-responsive-dialog-title"}
            PaperComponent={PaperComponent}
          >
            <DialogTitle id={"n-responsive-dialog-title"}>
              {"Source Sync Status"}
            </DialogTitle>
            <DialogContent>
              <div className={"row"}>
                <div className={"col-xs-2 top-xs"}>
                  <p style={{ marginTop: "20px" }}>{"Data Load date"}</p>
                </div>
                <div className={"col-xs-2 top-xs"}>
                  <p style={{ marginTop: "20px" }}>
                    <DatePicker
                      style={{ marginTop: "20px" }}
                      onDateChange={this.onDateRange}
                      startDate={this.state.syncStartDate}
                      endDate={this.state.syncEndDate}
                    />
                  </p>
                </div>
                <div className={"col-xs-2 top-xs"}>
                  <FormControl size={"small"} style={{ width: "100%" }}>
                    <InputLabel size={"small"} id={"dataSourcecolumnkeylabel"}>
                      {"Data source\r"}
                    </InputLabel>
                    <Select
                      size={"small"}
                      labelId={"dataSourcecolumnkeylabel"}
                      id={"datasourceColumnKeySelect"}
                      value={this.state.selectedDataSource || ""}
                      onChange={(event) => {
                        this.setState({
                          selectedDataSource: event.target.value,
                        });
                      }}
                    >
                      <MenuItem value={""}>
                        <em>{"All"}</em>
                      </MenuItem>
                      {this.state.dataSource &&
                        this.state.dataSource.map((key, index) => {
                          return (
                            <MenuItem
                              key={"dataSourceFieldkey" + index}
                              size={"small"}
                              value={key.dataSource}
                            >
                              {key.dataSource}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                </div>
                <div className={"col-xs-2 top-xs"}>
                  <FormControl
                    size={"small"}
                    key={"sourceStatus"}
                    style={{ width: "100%" }}
                  >
                    <InputLabel size={"small"} id={"statusSourcecolumnkeylabel"}>
                      {"Status\r"}
                    </InputLabel>
                    <Select
                      size={"small"}
                      labelId={"statusSourcecolumnkeylabel"}
                      id={"statusSourceColumnKeySelect"}
                      value={this.state.SelectedSyncStatus || ""}
                      onChange={(event) => {
                        this.setState({
                          SelectedSyncStatus: event.target.value,
                        });
                      }}
                    >
                      <MenuItem value={""} key={"syncStatusAll"}>
                        <em>{"All"}</em>
                      </MenuItem>
                      {this.state.syncStatus &&
                        this.state.syncStatus.map((key, index) => {
                          return (
                            <MenuItem
                              key={"statusSourceFieldkey" + index}
                              size={"small"}
                              value={key.status}
                            >
                              {key.status}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                </div>

                <div className={"col-xs-3 pull-right end-xs top-xs"}>
                  <p style={{ marginTop: "20px" }}>
                    <Button
                      variant={"contained"}
                      size={"small"}
                      style={{ marginRight: "10px", width: "140px" }}
                      onClick={() => {
                        this.getDataSyncDetails(
                          this.state.syncStartDate,
                          this.state.syncEndDate
                        );
                      }}
                      aria-label={"close"}
                    >
                      {"Submit\r"}
                    </Button>
                    {this.state.SyncData &&
                      this.state.SyncData.length > 0 &&
                      this.DownloadData(this.state.SyncData || [])}
                  </p>
                </div>

                <div className={"col-xs-12 pull-right end-xs top-xs"}>
                  <a
                    href={"#"}
                    onClick={() => {
                      this.openMissingPopupDetails();
                    }}
                  >
                    {" "}
                    {"View Missing Data\r"}
                  </a>
                </div>
                <div className={"col-xs-12"}>
                  <DenseTable
                    columns={SyncColumns}
                    data={this.state.SyncData || []}
                  />
                </div>
              </div>
            </DialogContent>
          </Dialog>
        )}
        {this.state.openMissingPopup && (
          <Dialog
            fullScreen={false}
            open={this.state.openMissingPopup}
            maxWidth={"sm"}
            onClose={() => {
              this.setState({ openMissingPopup: false });
            }}
            aria-labelledby={"n-responsive-Missing-dialog-title"}
            PaperComponent={PaperComponent}
          >
            <DialogTitle id={"n-responsive-Missing-dialog-title"}>
              {"Missing Data"}
            </DialogTitle>
            <DialogContent>
              <div className={"row"}>
                <div className={"col-xs-12"}>
                  <DenseTable
                    columns={MissingSyncColumns}
                    data={this.state.MissingSyncData || []}
                  />
                </div>
              </div>
            </DialogContent>
          </Dialog>
        )}
        {layout.isAuthenticated == true ? (
          <div>
            <Footer />
          </div>
        ) : null}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    user: { isLoading, userData },
    loaderConfig: { requestCount },
  } = state;
  return {
    isLoading,
    layout: state.layoutConfig,
    requestCount,
    userData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserData: (param) => dispatch(getUserData(param)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Layout);
